/**
 * Bridge for the race where assistant-ui's useLocalRuntime reads
 * `threadListItem.remoteId` via React state, but `initialize()` + `append()`
 * can run in the same tick before that state flushes into the model adapter.
 */
let activeRemoteThreadId: string | undefined

export function setActiveRemoteThreadId(remoteId: string | undefined): void {
  activeRemoteThreadId = remoteId || undefined
}

export function getActiveRemoteThreadId(): string | undefined {
  return activeRemoteThreadId
}
